export default __webpack_public_path__ + "static/media/lights.51570633.gif";